import { BarLoader } from 'react-spinners';

export const Loader = () => {
  const override = {
    display: 'block',
    height: '5px',
    width: '100px',
    margin: '150px auto 150px auto',
  };
  return (
    <BarLoader color="#559ed6" cssOverride={override} speedMultiplier={1.2} />
  );
};
